// extracted by mini-css-extract-plugin
export var active = "_e1-7";
export var container = "_e1-0";
export var evenWidth = "_e1-4";
export var large = "_e1-5";
export var outlet = "_e1-8";
export var slide = "_e1-2";
export var small = "_e1-6";
export var tab = "_e1-3";
export var tabs = "_e1-1";